import React, { useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../App";
import { toast } from '../utils/toast';
import LoginModal from "./LoginModal";
import './ProtectedRoute.css';

const ProtectedRoute = ({ children, showModal = false }) => {
  const { user, loading } = useContext(AuthContext);
  const location = useLocation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (!loading && !user) {
      // Store the attempted URL for redirect after login
      sessionStorage.setItem('redirectAfterLogin', location.pathname + location.search);
      
      if (showModal) {
        // Show login modal for certain pages
        setIsModalOpen(true);
      } else {
        // Redirect to landing for other pages
        toast.info("Please sign in to continue");
      }
    }
  }, [user, loading, location, showModal]);

  // Show nothing while checking authentication
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #f5f7fa 0%, #e8eef5 100%)'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div className="loading-spinner" style={{
            width: '48px',
            height: '48px',
            border: '4px solid #e5e7eb',
            borderTop: '4px solid #8448fc',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 16px'
          }}></div>
          <p style={{ color: '#6b7280' }}>Loading...</p>
        </div>
      </div>
    );
  }

  // If not authenticated and modal mode, show modal with page content
  if (!user && showModal) {
    return (
      <>
        {children}
        <LoginModal 
          isOpen={isModalOpen} 
          onClose={() => setIsModalOpen(false)}
          returnUrl={location.pathname + location.search}
        />
      </>
    );
  }

  // If not authenticated and not modal mode, redirect to landing page
  if (!user) {
    return <Navigate to="/" replace />;
  }

  // If authenticated, render the protected content
  return children;
};

export default ProtectedRoute;
